import React from 'react';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DefaultRouter } from './router';
import './App.css';

const queryClient = new QueryClient();
export const App: React.FC = () => (
    <QueryClientProvider client={queryClient}>
        <Toaster position="top-center" reverseOrder={false} />
        <DefaultRouter />
    </QueryClientProvider>
);

export default App;
